import type { LngLat, RouteOptions } from '@yandex/ymaps3-types';

// The function for fetching a route between two points
export async function fetchRoute(
    startCoordinates: LngLat,
    endCoordinates: LngLat,
    type: RouteOptions['type'] = 'walking'
) {
    // Request a route from the Router API with the specified parameters.
    const routes = await ymaps3.route({
        points: [startCoordinates, endCoordinates], // Start and end points of the route LngLat[]
        type, // Type of the route
        bounds: true, // Flag indicating whether to include route boundaries in the response
    });

    // Check if a route was found
    if (!routes[0]) {
        return;
    }

    // Convert the received route to a RouteFeature object.
    const route = routes[0].toRoute();

    // Check if a route has coordinates
    if (route.geometry.coordinates.length === 0) {
        return;
    }

    return route;
}
